import React, {Fragment, FunctionComponent, useEffect} from "react"
import {useDispatch, useSelector} from "react-redux";
import {actionCreators, State} from '@App/state'
import {Gearbox} from "@App/types";
import {useTranslation} from "react-i18next";
import {bindActionCreators} from "@reduxjs/toolkit";
import {GearboxList, GearboxListSkeleton} from "@App/Components/Vehicletree/GearboxList";
import {FunnelHeader} from "@App/Components/Funnel/FunnelHeader";

export type GearboxesProps = {
    headline: string
    step: number
    maxSteps: number
    onSubmit?: (gearbox: Gearbox) => void
}

export const Gearboxes: FunctionComponent<GearboxesProps> = ({headline, step, maxSteps, onSubmit}: GearboxesProps) => {
    const {t} = useTranslation()
    const motorization = useSelector((state: State) => state.orders.motorization)
    const gearbox = useSelector((state: State) => state.orders.gearbox)

    const dispatch = useDispatch();
    const {chooseGearbox} = bindActionCreators(actionCreators, dispatch)

    const setGearbox = (gearbox: Gearbox): void => {
        chooseGearbox(gearbox)
        onSubmit && onSubmit(gearbox)
    }

    // step over if only one option available
    useEffect(() => {
        if (gearbox) {
            return
        }

        // set gearbox if only one option available
        if (motorization && motorization.gearboxes.length === 1) {
            setGearbox(motorization.gearboxes[0])
        }
        if (motorization && motorization.gearboxes.length === 0) {
            // set default gearbox if no gearboxes available
            setGearbox({
                id: 1,
                name: 'ManualGearBox',
                formatted_name: 'Schaltgetriebe'
            })
        }
    }, [motorization])

    return (
        <Fragment>
            <div className="
                    container bg-white
                    pt-10 pb-12
                ">
                <FunnelHeader heading={headline}
                              step={step}
                              maxSteps={maxSteps}
                              subheading={t('gearbox.headline')}
                              description={t('gearbox.subheadline')}
                />
                {!motorization && (
                    <GearboxListSkeleton/>
                )}
                {motorization && motorization.gearboxes.length > 0 && (
                    <GearboxList gearboxes={motorization.gearboxes} onClick={setGearbox}/>
                )}
                {motorization && motorization.gearboxes.length === 0 && (
                    <GearboxList gearboxes={[
                        {
                            id: 1,
                            name: 'ManualGearBox',
                            formatted_name: 'Schaltgetriebe'
                        },
                        {
                            id: 2,
                            name: 'AutomaticGearBox',
                            formatted_name: 'Automatikgetriebe'
                        }
                    ]} onClick={setGearbox}/>
                )}
            </div>
        </Fragment>
    );
}
